import React from "react";

import { toCurrency } from "../../utils/currency";

const translations = {
  "en-US": {
    from: "from",
    per_person_night: "per person/night",
    per_night: "per night",
    per_person: "per person"
  },
  "no-NO": {
    from: "fra",
    per_person_night: "per person/natt",
    per_night: "per natt",
    per_person: "per person"
  },
  "nb-NO": {
    from: "fra",
    per_person_night: "per person/natt",
    per_night: "per natt",
    per_person: "per person"
  }
}

const Pricing = ({ price, removeFrom = false, language = "no-NO", pricingType }) => {
  if (!price) return null;
  return (
    <div className="flex flex-col text-sm items-end text-[#75757D] mb-[10px] leading-[0.5] whitespace-nowrap">
      { removeFrom ? null : translations[language].from }
      <div className="flex text-black text-lg">
        {toCurrency({ value: price.amount, valueCurrency: price.currency})}
      </div>
      {pricingType ? <span>{translations[language][pricingType]}</span> : null}
    </div>
  )
}

export default Pricing;